<template>
    <div class="contract_wrap">
        <div class="top_box flex ais">
            <div class="base_info">
                <p>{{ query.type == 'contract' ? '正式合同' : '项目变更单' }}</p>
                <p>{{ query.type == 'contract' ? baseInfo.new_code : baseInfo.new_name }}</p>
                <p class="time">创建时间：{{ baseInfo.createdon || '--' }}</p>
                <p v-if="status != 1 && status != 2" class="time">审核时间：{{ baseInfo.new_approved_time || '--' }}</p>
            </div>
            <img v-if="status == 1" src="~@/assets/images/archives/preparation.png" alt="制单">
            <img v-if="status == 2" src="~@/assets/images/archives/modifying.png" alt="审核中">
            <img v-if="status == 3" src="~@/assets/images/archives/reviewed.png" alt="已审核">
            <img v-if="status == 4" src="~@/assets/images/archives/rejected.png" alt="已驳回">
            <img v-if="status == 5" src="~@/assets/images/archives/unqualified.png" alt="已否决">
        </div>
        <div class="tab_box flex aic">
            <div :class="{'tab_item':true,'tab_item_select':nTabIndex == 0}" @click="touchTab(0)">
                {{ query.type == 'contract' ? '合同信息' : '变更信息' }}
            </div>
            <div :class="{'tab_item':true,'tab_item_select':nTabIndex == 1}" @click="touchTab(1)">
                {{ query.type == 'contract' ? '合同附件' : '变更附件' }}
            </div>
            <div :class="{'tab_item':true,'tab_item_select':nTabIndex == 2}" @click="touchTab(2)">审批流</div>
        </div>
        <div class="list_box">
            <div v-for="(item,index) in list" :key="index" class="list_item">
                <div class="list_title flex aic">
                    <p class="title">{{ item.title }}</p>
                    <div v-if="item.type == 2" class="product_info flex">
                        <p>数量：{{ item.num }}</p>
                        <p>总计：<span>¥ {{ item.toastMeny }}</span></p>
                    </div>
                    <div v-if="item.type == 4" class="step_unfold flex aic" @click="touchUnfold(index)">
                        <p>{{ item.isUnfold ? '收起' : '展开' }}</p>
                        <img :class="{'arrow':true,'arrow2':item.isUnfold}"
                             src="~@/assets/images/archives/dossier/arrow_icon2.png" alt="">
                    </div>
                </div>
                <!--文本-->
                <div v-if="item.type == 1" class="msg_list">
                    <div v-for="(item2,index2) in item.msg" :key="index2"
                         :class="{'msg_item flex':true,'msg_red':item2.isRed}">
                        <p>{{ item2.label }}：</p>
                        <p>{{ item2.value || '--' }}</p>
                    </div>
                </div>
                <!--产品-->
                <div v-if="item.type == 2"
                     :class="{'product_list':true, 'product_list2':item.msg.length > 3, 'product_list_unfold':item.isUnfold}">
                    <div v-for="(item2,index2) in item.msg" :key="index2"
                         :class="{'product_item flex aic':true,'opacity50':item2.is_add == 2}">
                        <div v-if="item2.is_add == 1 ||item2.is_add == 2 || item2.is_add == 3"
                             :class="{'add_item':true,'add_item_green':item2.is_add == 1,'add_item_red':item2.is_add == 2,'add_item_black':item2.is_add == 3}">
                            {{ item2.add_text }}
                        </div>
                        <div class="product_img">
                            <img v-if="item2.img" :src="item2.img" alt="">
                        </div>
                        <div class="product_msg">
                            <P>{{ item2.type_name || '' }}</P>
                            <P>{{ item2.new_fivecopynumber || '' }}</P>
                            <br/>
                            <P>{{ item2.name || '' }}</P>
                            <P>折扣率：{{ item2.new_discount || '0.00' }}%</P>
                            <br/>
                            <div class="bottom flex">
                                <P>{{ item2.num || '' }}件</P>
                                <P>¥ {{ item2.amount || '' }}</P>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.msg.length > 3"
                         :class="{'unfold_box flex aic juc':true,'unfold_box2':item.isUnfold}"
                         @click="touchUnfold(index)">
                        <img src="~@/assets/images/archives/dossier/arrow_icon.png" alt="">
                        <p>展开显示更多</p>
                    </div>
                </div>
                <!--附件-->
                <div v-if="item.type == 3" class="file_list flex fnw">
                    <img v-for="(item2,index2) in item.img" :key="index2" :src="item2" alt=""
                         @click="touchLookImg(index)">
                </div>
                <!--流程-->
                <div v-if="item.type == 4" :class="{'step_list':true, 'step_list_unfold':item.isUnfold}">
                    <div v-for="(item2,index2) in item.step" :key="index2" class="step_item">
                        <img :class="['step_icon',{'step_icon2':item2.new_approvedate}]"
                             src="~@/assets/images/archives/dossier/time_icon.png" alt="">
                        <div class="step_info flex ais">
                            <div class="step_name">
                                <p>{{ item2.new_name }}</p>
                                <p>{{ item2.username }}</p>
                            </div>
                            <div v-if="item2.new_approvedate" class="step_state">
                                <p>{{ item2.new_status_text || '--' }}</p>
                                <p>{{ item2.new_approvedate }}</p>
                            </div>
                        </div>
                        <div v-if="item2.new_result" class="step_msg">{{ item2.new_result }}</div>
                    </div>
                    <div class="them_box">
                        知会人：<span>{{ item.them || '暂无' }}</span>
                    </div>
                </div>
                <!--记录-->
                <div v-if="item.type == 5" class="record_list">
                    <div v-for="(item2,index2) in item.time" :key="index2" class="record_item">
                        <div class="record_date">
                            <img class="record_icon" src="~@/assets/images/archives/dossier/time_icon.png" alt="">
                            <p>{{ item2.time }}</p>
                        </div>
                        <div v-for="(item3,index3) in item2.record" :key="index3" class="record_box">
                            <div class="record_time">{{ item3.new_date_min }}</div>
                            <div class="record_info">
                                <p>{{ item3.new_name }}</p>
                                <div class="record_name flex">
                                    {{ item3.new_username }}
                                    <span>{{ item3.result }}</span>
                                </div>
                            </div>
                            <div v-if="item3.new_memo != ''" class="record_msg">{{ item3.new_memo }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_btns flex aic jue">
            <button v-if="query.type == 'change'" @click="touchLookRecord">查看变更记录</button>
            <!--            <button>修改合同</button>-->
            <!--            <button>提交审核</button>-->
        </div>

        <img class="back_icon" @click="touchBack" src="~@/assets/images/archives/dossier/back_icon.png"/>

    </div>
</template>

<script>
//ImagePreview

import {ImagePreview} from "vant";
import {getApprovallogInfo, getChangeInfo, getContractInfo} from "@/js/archives/dossier";

export default {
    name: "ContractDetails",
    components: {},
    data() {
        return {
            type: 'contract', //type contract - 合同， change - 变更单
            status: -1,//1-制单，2-审核中，3-已审核，4-已驳回，5-已否决
            nTabIndex: 0,
            query: {},
            list: [],
            baseInfo: {},
            arrInfo: [{
                title: '合同信息',
                type: 1,//1 - label文本，2- 产品信息 ，3 - 图片列表 ， 4 - 流程 ， 5 -记录
                msg: [{
                    label: '合同类型',
                    key: 'new_contracttype',
                    value: ''
                }, {
                    label: '合同编号',
                    key: 'new_code',
                    value: ''
                }, {
                    label: '项目类型',
                    key: 'new_projecttype',
                    value: ''
                }, {
                    label: '设备销售总价',
                    key: 'new_salesamount',
                    value: ''
                }, {
                    label: '系统安装总价',
                    key: 'new_installamount',
                    value: ''
                }, {
                    label: '合同总金额',
                    key: 'new_totalamount',
                    value: ''
                }, {
                    label: '项目报价',
                    key: 'new_projectamount',
                    value: ''
                }, {
                    label: '开票方式',
                    key: 'new_invoicetype',
                    value: ''
                }, {
                    label: '信息来源',
                    key: 'new_account_source',
                    value: ''
                }, {
                    label: '门店信息',
                    key: 'new_store_id',
                    value: ''
                }, {
                    label: '门店上层组织名称',
                    key: 'new_parentorgname',
                    value: ''
                }, {
                    label: '渠道名称',
                    key: 'new_channeldesc',
                    value: ''
                }, {
                    label: '锅炉合同号',
                    key: 'new_contractbillno',
                    value: ''
                }, {
                    label: '系统合同号',
                    key: 'new_contractbillno2',
                    value: ''
                }, {
                    label: '锅炉妥投码',
                    key: 'new_delievered1',
                    value: ''
                }, {
                    label: '系统妥投码',
                    keu: 'new_delievered2',
                    value: ''
                }]
            }, {
                title: '房屋信息',
                type: 1,
                msg: [{
                    label: '房屋类型',
                    key: 'new_housetype',
                    value: ''
                }, {
                    label: '户型结构',
                    key: 'new_roomtype',
                    value: ''
                }, {
                    label: '建筑面积',
                    key: 'new_area',
                    value: ''
                }, {
                    label: '装修情况',
                    key: 'new_fitstatus',
                    value: ''
                }]
            }, {
                title: '合同收款',
                type: 1,
                msg: [{
                    label: '付款方式',
                    key: 'new_paymenttype',
                    value: ''
                }, {
                    label: '收款渠道',
                    key: 'new_paymentchannel',
                    value: ''
                }, {
                    label: '收款方式',
                    key: 'new_receipttype',
                    value: ''
                }, {
                    label: '收款时间',
                    key: 'new_secondpaymentdate',
                    value: ''
                }]
            }, {
                title: '产品明细',
                type: 2,
                num: 0,
                isUnfold: false,
                menyKey: 'product_totalprice',
                toastMeny: '',
                msgKey: 'product_list',
                msg: []
            }], //合同信息
            fileKey: 'attachment',
            arrFile: [{
                title: '合同附件',
                type: 3,
                img: []
            }, {
                title: '付款凭证',
                type: 3,
                img: []
            }, {
                title: '方案或配置表',
                type: 3,
                img: []
            }], //合同附件
            arrChangeInfo: [{
                title: '变更信息',
                type: 1,//1 - label文本，2- 产品信息 ，3 - 图片列表 ， 4 - 流程 ， 5 -记录
                msg: [{
                    label: '合同类型',
                    key: 'new_contracttype',
                    value: ''
                }, {
                    label: '合同编号',
                    key: 'new_name',
                    value: ''
                }, {
                    label: '变更原因',
                    key: 'new_reason',
                    value: ''
                }, {
                    label: '项目类型',
                    isRed: true,
                    key: 'new_projecttype',
                    value: ''
                }, {
                    label: '是否项目终止',
                    key: 'new_isterminate',
                    value: ''
                }]
            }, {
                title: '变更收款',
                type: 1,
                msg: [{
                    label: '收费情况',
                    key: 'new_ischarge',
                    value: ''
                }, {
                    label: '变更金额',
                    isRed: true,
                    key: 'new_amount',
                    value: ''
                }, {
                    label: '减免金额',
                    isRed: true,
                    key: 'new_reductionamount',
                    value: ''
                }, {
                    label: '实际变更金额',
                    isRed: true,
                    key: 'new_actualamount',
                    value: ''
                }, {
                    label: '收退款渠道',
                    key: 'new_paymentchannel',
                    value: ''
                }, {
                    label: '变更描述',
                    key: 'new_memo',
                    value: ''
                }]
            }, {
                title: '产品明细',
                type: 2,
                num: 0,
                isUnfold: false,
                menyKey: 'product_totalprice',
                toastMeny: '',
                msgKey: 'product_list',
                msg: []
            }], //变更信息
            arrChangeFile: [{
                title: '项目变更附件',
                type: 3,
                img: []
            }], //变更附件
            arrStep: [{
                title: '审批流程',
                key: 'steps',
                type: 4,
                isUnfold: true,
                themKey: 'notify',
                them: '张建国; 徐同伟; 朱占伟',
                step: []
            }, {
                title: '审批记录',
                key: 'loglist',
                type: 5,
                time: []
            }], //审批流
        }
    },
    mounted() {
        console.log('query', this.$route.query);
        this.query = this.$route.query;
        this.list = this.query.type == 'change' ? this.arrChangeInfo : this.arrInfo;
        this.$store.commit("loadSwitch", true);
        if (this.query.type == 'change') {
            this.getChangeInfoFun()
        } else {
            this.getContractInfoFun()
        }
        //获取审批流
        getApprovallogInfo({
            form_id: this.query.type == 'change' ? this.query.change_id : this.query.contract_id
        }).then((res) => {
            this.handleLogData(res.data.data.result)
        })
    },
    methods: {
        touchTab(i) {
            this.nTabIndex = i;
            switch (i) {
                case 0:
                    this.list = this.query.type == 'change' ? this.arrChangeInfo : this.arrInfo;
                    break;
                case 1:
                    this.list = this.query.type == 'change' ? this.arrChangeFile : this.arrFile;
                    break;
                case 2:
                    this.list = this.arrStep;
                    break;
            }
        },
        touchUnfold(i) {
            this.list[i].isUnfold = !this.list[i].isUnfold;
        },
        touchLookImg(i) {
            let arrImg = this.list[i].img;
            ImagePreview(arrImg)
        },
        //获取合同详情
        getContractInfoFun() {
            getContractInfo({
                contract_id: this.query.contract_id
            }).then((res) => {
                this.$store.commit("loadSwitch", false);
                this.handleData(this.arrInfo, res.data.data.result);
            })
        },
        //获取变更详情
        getChangeInfoFun() {
            getChangeInfo({
                contract_id: this.query.contract_id,
                change_id: this.query.change_id
            }).then((res) => {
                this.$store.commit("loadSwitch", false);
                this.handleData(this.arrChangeInfo, res.data.data.result);
            })
        },
        touchLookRecord() {
            this.$router.push({
                path: `/archives/contract/record`,
                query: this.query
            })
        },
        //处理信息和附件数据
        handleData(list, data) {
            console.log('info', data)
            this.baseInfo = {
                new_code: data.new_code,
                new_name: data.new_name,
                createdon: (data.createdon || '').replaceAll('-', '/'),
                new_approved_time: (data.new_approved_time || '').replaceAll('-', '/'),
            }
            this.status = data.status;
            list.forEach((item) => {
                if (item.type == 1) {
                    item.msg.forEach((item2) => {
                        item2.value = data[item2.key]
                    })
                } else if (item.type == 2) {
                    item.msg = data[item.msgKey];
                    item.toastMeny = data[item.menyKey];
                    item.num = item.msg.length;
                }
            })
            if (this.query.type == 'change') {
                this.arrChangeFile[0].img = data[this.fileKey]
            } else {
                let objFile = data[this.fileKey]
                this.arrFile.forEach((item) => {
                    item.img = objFile[item.title]
                })
            }
            this.list = list;
            this.$store.commit("loadSwitch", false);
        },
        //处理审批流程数据
        handleLogData(data) {
            console.log('getApprovallogInfo', data)
            this.arrStep.forEach((item) => {
                if (item.type == 4) {
                    item.step = data[item.key];
                    item.them = data[item.themKey].join('、');
                } else if (item.type == 5) {
                    for (const key in data[item.key]) {
                        item.time.push({
                            time: key,
                            record: data[item.key][key]
                        })
                    }
                }
            })
        },
        touchBack() {
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
}

.aic {
    align-items: center;
}

.ais {
    align-items: flex-start;
}

.aie {
    align-items: flex-end;
}

.juc {
    justify-content: center;
}

.jue {
    justify-content: flex-end;
}

.jusb {
    justify-content: space-between;
}

.fw {
    flex-wrap: wrap;
}

.fnw {
    flex-wrap: nowrap;
}

.contract_wrap {
    width: 100%;
    min-height: 100vh;
    background: #F9F9FB;
    background: linear-gradient(
            #F3F6FF 0%,
            #F3F6FF 480px,
            #F9F9FB 480px
    );
    padding: 32px 0 calc(128px + env(safe-area-inset-bottom));

    .top_box {
        padding: 38px 32px 28px;

        .base_info {
            p:nth-child(1) {
                font-size: 36px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 42px;
                display: inline-block;
            }

            p:nth-child(2) {
                margin-left: 16px;
                display: inline-block;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #949699;
                line-height: 28px;
            }

            .time {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
                line-height: 28px;
                margin-top: 16px;
            }
        }

        img {
            width: 161px;
            height: 153px;
            display: block;
            margin-left: auto;
        }
    }

    .tab_box {
        width: 686px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 16px;
        margin: 0 auto 16px;

        .tab_item {
            flex: 1;
            text-align: center;
            height: 100%;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #A3A3A3;
            line-height: 80px;
            position: relative;
            transition: color 0.2s;
        }

        .tab_item::after {
            content: "";
            display: block;
            width: 0;
            height: 5px;
            background: #0D53FC;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            transition: width 0.2s;
        }

        .tab_item_select {
            content: "";
            font-weight: bold;
            color: #0D53FC;
        }

        .tab_item_select::after {
            width: 96px;
        }
    }

    .list_box {
        padding: 0 32px;

        .list_item {
            background: #FFFFFF;
            border-radius: 16px;
            margin-bottom: 16px;
        }

        .list_title {
            position: relative;
            padding-left: 64px;

            .title {
                font-size: 24px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: bold;
                color: $blackText;
                line-height: 98px;
            }

            .product_info {
                margin-left: auto;

                p {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    color: #3E3D50;
                    height: 28px;
                    line-height: 28px;
                }

                p:nth-child(1) {
                    padding-right: 10px;
                    border-right: 1px solid #3E3D50;
                }

                p:nth-child(2) {
                    padding-left: 10px;
                    padding-right: 32px;

                    span {
                        color: #EA5F56;
                        font-weight: bold;
                    }
                }
            }

            .step_unfold {
                margin-left: auto;
                padding-right: 32px;

                p {
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: bold;
                    color: #0D53FC;
                    line-height: 34px;
                }

                .arrow {
                    width: 24px;
                    height: 24px;
                    display: block;
                    margin-left: 8px;
                    transition: transform 0.2s;
                    transform: rotate(180deg);
                }

                .arrow2 {
                    transform: rotate(0deg);
                }
            }
        }

        .list_title::after {
            content: "";
            position: absolute;
            top: 36px;
            left: 44px;
            display: block;
            width: 4px;
            height: 26px;
            background: #0D53FC;
        }

        .msg_list {
            padding: 0 64px;
        }

        .msg_item {
            padding-bottom: 16px;

            p {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #A3A3A3;
                line-height: 34px;
            }

            p:nth-child(1) {
                width: 264px;
            }

            p:nth-child(2) {
                color: #3E3D50;
            }
        }

        .msg_red {
            p {
                color: #E95859 !important;
            }
        }

        .msg_item:nth-last-child(1) {
            padding-bottom: 32px;
        }

        .product_list {
            padding: 0 32px;
            overflow: hidden;
            border-top: 2px solid #F2F2F2;
            position: relative;

            .product_item {
                width: 100%;
                height: 218px;
                border-bottom: 2px solid #F2F2F2;
                position: relative;
            }

            .add_item {
                position: absolute;
                top: 35px;
                right: 0;
                padding: 0 16px;
                border-radius: 16px;
                text-align: center;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 28px;
            }

            .add_item_green {
                border: 2px solid #24AE71;
                color: #24AE71;
            }

            .add_item_red {
                border: 2px solid #E95859;
                color: #E95859;
            }

            .add_item_black {
                border: 2px solid #000000;
                color: #000000;
            }

            .product_img {
                width: 128px;
                height: 128px;
                background: #F9F9FB;
                border-radius: 16px;
                margin-right: 32px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    border-radius: 16px;
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    display: block;
                }
            }


            .product_msg {
                width: calc(100% - 160px);

                p {
                    display: inline-block;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    line-height: 34px;
                    margin-bottom: 8px;
                }

                p:nth-child(1) {
                    display: block;
                    font-weight: bold;
                    color: $blackText;
                    line-height: 34px;
                }

                p:nth-child(2) {
                    color: $blackText;
                    //margin-left: 16px;
                }

                p:nth-child(4) {
                    color: $greyText;
                }

                p:nth-child(5) {
                    color: $greyText;
                    margin-left: 18px;
                }

                .bottom {
                    width: 100%;

                    p {
                        display: block;
                        margin-bottom: 0;
                    }

                    p:nth-child(1) {
                        color: $greyText;
                        font-weight: normal;
                        margin-right: auto;
                    }

                    p:nth-child(2) {
                        font-size: 28px;
                        font-weight: bold;
                        color: #EA5F56;
                    }
                }

            }

            .unfold_box {
                width: 100%;
                position: absolute;
                left: 0;
                bottom: 0;
                background: #FFFFFF;

                img {
                    width: 32px;
                    height: 32px;
                    display: block;
                    margin-right: 16px;
                    transform: rotate(90deg);
                    transition: transform 0.2s;
                }

                p {
                    font-size: 24px;
                    font-family: Alata-Regular, Alata;
                    font-weight: 400;
                    color: #CCCCCC;
                    line-height: 98px;
                }
            }

            .unfold_box2 {
                img {
                    transform: rotate(-90deg);
                }
            }
        }

        .product_list2 {
            height: 754px;
        }

        .product_list_unfold {
            height: auto;
            padding-bottom: 98px;
        }

        .opacity50 {
            opacity: 0.5;
        }

        .file_list {
            width: 100%;
            padding: 32px 0 48px 32px;
            overflow-y: scroll;

            img {
                width: 160px;
                min-width: 160px;
                height: 160px;
                background: #F9F9FB;
                border-radius: 16px;
                display: block;
                margin-right: 18px;
                object-fit: contain;
            }
        }

        .step_list {
            width: 100%;
            height: 0;
            padding-top: 0;
            overflow: hidden;
            position: relative;

            .step_item {
                padding: 0 48px 64px 140px;
                position: relative;
                z-index: 10;

                .step_icon {
                    width: 64px;
                    height: 64px;
                    display: block;
                    position: absolute;
                    left: 44px;
                    top: 0;
                    filter:grayscale(100%)
                }

                .step_icon2{
                    filter:grayscale(0%)
                }

                .step_info {
                    padding-bottom: 20px;
                }

                .step_name {
                    p:nth-child(1) {
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: $greyText;
                        line-height: 34px;
                    }

                    p:nth-child(2) {
                        font-size: 28px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: bold;
                        color: #333333;
                        line-height: 40px;
                        padding-top: 12px;
                    }
                }

                .step_state {
                    margin-left: auto;

                    p {
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: $greyText;
                        line-height: 34px;
                        text-align: right;
                    }

                    p:nth-child(1) {
                        padding-bottom: 14px;
                    }
                }

                .step_msg {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: $greyText;
                    line-height: 34px;
                }
            }

            .step_item:nth-last-child(2) {
                background: #FFFFFF;
            }

            .them_box {
                position: relative;
                z-index: 10;
                background: #FFFFFF;
                border-radius: 0 0 16px 16px;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                color: #A3A3A3;
                line-height: 34px;
                padding: 48px;

                border-top: 2px solid #F5F5F5;

                span {
                    font-weight: bold;
                    color: #3D3C4F;
                }

            }
        }

        .step_list::after {
            content: "";
            position: absolute;
            top: 66px;
            left: 74px;
            z-index: 0;
            width: 4px;
            height: calc(100% - 66px);
            background-image: linear-gradient(
                    #EEEEEE 0%,
                    #EEEEEE 50%,
                    transparent 50%
            );
            background-size: 100% 16px;
            background-repeat: repeat-y;
        }

        .step_list_unfold {
            height: auto;
            padding-top: 66px;
        }


        .record_list {
            padding-left: 44px;

            .record_item {
                position: relative;
                padding-right: 48px;

                .record_date {
                    padding-left: 96px;
                    position: relative;
                    font-size: 28px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: $blackText;
                    line-height: 64px;
                    padding-bottom: 80px;
                }

                .record_icon {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 64px;
                    height: 64px;
                    z-index: 1;
                }

                .record_box {
                    padding-left: 96px;
                    padding-bottom: 64px;
                    position: relative;
                    z-index: 10;
                }

                .record_box:nth-last-child(1) {
                    background: #FFFFFF;
                }

                .record_time {
                    position: absolute;
                    left: 0;
                    top: 0;
                    background: #FFFFFF;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 34px;
                }

                .record_info {
                    margin-bottom: 16px;

                    p {
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 34px;
                    }

                    .record_name {
                        font-size: 28px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: $blackText;
                        line-height: 40px;
                        margin-top: 8px;

                        span {
                            font-size: 24px;
                            font-weight: normal;
                            color: #24AE71;

                            margin-left: auto;
                        }
                    }
                }

                .record_msg {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: $greyText;
                    line-height: 34px;
                }
            }

            .record_item::after {
                content: "";
                position: absolute;
                top: 66px;
                left: 30px;
                z-index: 0;
                width: 4px;
                height: calc(100% - 66px);
                background-image: linear-gradient(
                        #EEEEEE 0%,
                        #EEEEEE 50%,
                        transparent 50%
                );
                background-size: 100% 16px;
                background-repeat: repeat-y;
            }
        }


        //record_box
        //record_item
        //record_msg

    }

    .bottom_btns {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
        background: #FFFFFF;
        width: 100%;
        height: calc(112px + env(safe-area-inset-bottom));
        padding: 0 32px env(safe-area-inset-bottom);
        box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.03);

        button {
            width: 160px;
            height: 64px;
            background: #0D53FC;
            border-radius: 16px;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 64px;
            text-align: center;
            margin-left: 16px;
            border: 2px solid #0D53FC;
        }

        .red_btn {
            color: #E95859;
            background: #FFFFFF;
            border: 2px solid #E95859;
        }

        .green_btn {
            background: #24AE71;
            border: 2px solid #24AE71;
        }
    }
}

.back_icon {
    position: fixed;
    left: 32px;
    bottom: calc(env(safe-area-inset-bottom) + 150px);
    z-index: 999;
    width: 100px;
    height: 100px;
}
</style>
